export const LINKS = {
  buy:     'https://t.me/blum/app?startapp=memepadjetton_APX_xeVqQ-ref_SaGN8TJQmc',
  dex:     'https://dexscreener.com/ton/eqcwb0pvsrkxbiyw_h5rqatiepwfvnmqv_l7vdmmo7fgwfvo',
  chat:    'https://t.me/+Ln_CIinr9CMwY2My',
  channel: 'https://t.me/apextokenLIkUB',
  // Собственные продукты экосистемы APEX
  velarionDex:    'https://velarion.io',
  tronEnergySite: 'https://tron-enerjy.com/',
  tronEnergyBot:  'https://t.me/tron_lightning_bot',
};

export const TICKER_ITEMS = [
  '$APEX · TON Network',
  '50% Profit → Buyback',
  'Locked LP',
  'Audited Contract',
  'Real DeFi Yield',
  '1500 TON Raised in 24h',
  'Live on DEX',
  'Arbitrum · TRON · TON',
];

export const PALETTE = {
  bg:       '#050509',
  surface:  '#0D0D18',
  surface2: '#131320',
  border:   'rgba(255,255,255,0.07)',
  blue:     '#3B82F6',
  cyan:     '#06B6D4',
  silver:   '#9CA3AF',
  muted:    '#6B7280',
  dim:      '#4B5563',
};

export const ANALYTICS = {
  gaId: 'G-0BNB36RZX6',
  ymId: 110297710,
};
